(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['module', 'exports', 'lodash/isFunction'], factory);else if ('undefined' != typeof exports) factory(module, exports, require('lodash/isFunction'));else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.isFunction), global.set_progress = mod.exports;
  }
})(this, function (module, exports, _isFunction2) {
  'use strict';

  function getPercent(loaded, total, computable) {
    return computable ? 100 * (loaded / total) : 100;
  }

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports.default = function (progress) {
    return (0, _isFunction3.default)(progress) ? function (loaded, total, lengthComputable) {
      progress({
        percent: getPercent(loaded, total, lengthComputable),
        loaded: loaded,
        total: total
      });
    } : void 0;
  };

  var _isFunction3 = function (obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }(_isFunction2);

  module.exports = exports['default'];
});